import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full py-6 px-6 bg-[#f3ede6] border-t border-gray-200">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center text-sm">
          <div className="mb-4 md:mb-0">
            <p className="text-[#282f3a] font-medium">FetchMate by Matcha Design</p>
          </div>
          <div>
            <p className="text-[#282f3a]">
              © {currentYear} <a href="https://matchadesign.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#F2674C] transition-colors">Matcha Design</a>. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;